const imgData_2025 = {
  griys: {
    title: 'Griys',
    imgs: {
      full: {
        src: require('./griys_2025_web.jpg'),
        width: 1200,
        height: 1500,
      },
      thumb: {
        src: require('./griys_2025_thumb.jpg'),
        width: 480,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 8 x 10", 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "A Dungeons & Dragons character commission. Griys is half elf, half human and much prefers the company of animals to humans.<br /><br />This picture was commissioned as a gift, and the gifted person's cat also made it into the picture as a cameo.",
  },
  rocs_and_brynrfel: {
    title: 'Rocs and Brynrfel',
    imgs: {
      full: {
        src: require('./rocs_and_brynrfel_2025_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./rocs_and_brynrfel_2025_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 12 x 16", 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'Brynrfel, the son of the great oak has an uninvited visitor. This book cover illustration was commissioned for a book still in progress at the time of creation.',
  },
  lakeside_rest: {
    title: 'Lakeside Rest',
    imgs: {
      full: {
        src: require('./lakeside_rest_2025_web.jpg'),
        width: 1200,
        height: 1500,
      },
      thumb: {
        src: require('./lakeside_rest_2025_thumb.jpg'),
        width: 480,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 8 x 10", 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "Another fun commission from 2025. The client's sister loves dragons, but also loves their two cats. So I was to paint these two feline dragons at an idyllic lakeside.",
  },
  rona: {
    title: 'Rona',
    imgs: {
      full: {
        src: require('./rona_2025_web.jpg'),
        width: 1200,
        height: 1500,
      },
      thumb: {
        src: require('./rona_2025_thumb.jpg'),
        width: 480,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 8 x 10", 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'Rona is a girl who is a huge fan of the Wings of Fire series and this unique piece was commissioned by her mom to represent her own, powerful feminine character, inspired by bats.',
  },
  what_seemed_to_happen: {
    title: 'What Seemed to Happen',
    imgs: {
      full: {
        src: require('./what_seemed_to_happen_2025_web.jpg'),
        width: 1500,
        height: 1061,
      },
      thumb: {
        src: require('./what_seemed_to_happen_2025_thumb.jpg'),
        width: 600,
        height: 424,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 420 x 297 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "The first part of a painting pair commissioned to celebrate a fun moment of a pup's life.<br /><br />Here the scene looks like any ordinary life snippet... But is it really all what was happening?",
  },
  what_really_happened: {
    title: 'What Really Happened',
    imgs: {
      full: {
        src: require('./what_really_happened_2025_web.jpg'),
        width: 1500,
        height: 1061,
      },
      thumb: {
        src: require('./what_really_happened_2025_thumb.jpg'),
        width: 600,
        height: 424,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 420 x 297 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "The second part of a painting pair commissioned to celebrate a fun moment from a pup's life. All set in a D&D world.<br /><br />This painting shows the reality of the moment... A fierce stand-off between two mighty creatures, a battle of the era!",
  },
  rainbow_llama_unicorn: {
    title: 'Rainbow Llama Unicorn',
    imgs: {
      full: {
        src: require('./rainbow_llama_unicorn_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./rainbow_llama_unicorn_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 210 x 297 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'A commissioned avatar for... well, rainbowLlamaUnicorn.',
  },
  the_keeper_of_the_gates: {
    title: 'The Keeper of the Gates',
    imgs: {
      full: {
        src: require('./the_keeper_of_the_gates_2025_web.jpg'),
        width: 1200,
        height: 1500,
      },
      thumb: {
        src: require('./the_keeper_of_the_gates_2025_thumb.jpg'),
        width: 480,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 16 x 20", 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'Another D&D character commission. I love painting characters from this world! And The Keeper of The Gates is one hell of a character. This ancient dragon was killed in an explosion, but came back from the dead as powerful as ever. In the background there is molten wealth and radioactive volcanoes. Epic.',
  },
  the_lovers: {
    title: 'The Lovers',
    imgs: {
      full: {
        src: require('./the_lovers_2025_web.jpg'),
        width: 720,
        height: 1008,
      },
      thumb: {
        src: require('./the_lovers_2025_thumb.jpg'),
        width: 429,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 5 x 7", 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A tattoo design commission inspired by the tarot card "Lovers" and the Titanosaurus pair from Jurassic Park.',
  },
  snake_bear: {
    title: 'Snake Bear',
    imgs: {
      full: {
        src: require('./snake_bear_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./snake_bear_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 420 x 597 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'I was commissioned to paint a half-snake, half-bear creature. These two animals are not the closest in appearance so it took me some time to come up with the concept. But the result is a truly unique creature!',
  },
  six_stars: {
    title: 'Six Stars',
    imgs: {
      full: {
        src: require('./six_stars_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./six_stars_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper, 210 x 297 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A very special tattoo commission. This was made for a university professor who wanted to get his first ever tattoo on his 70th birthday.',
  },
  rosehips: {
    title: 'Rosehips',
    imgs: {
      full: {
        src: require('./rosehips_2025_web.jpg'),
        width: 1076,
        height: 1500,
      },
      thumb: {
        src: require('./rosehips_2025_thumb.jpg'),
        width: 430,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen on paper. 250 x 350 mm, 2025.',
    price: 226,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1898455801/',
    ship: 'FREE_IRL',
    merch: [
      {
        name: 'Colouring Page - Printed',
        url: 'https://www.etsy.com/ie/listing/1898439055/',
        /* prettier-ignore */
        price: 6.50,
        discount: 0,
      },
    ],
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'I was further exploring the different marker shades for pen drawings. This technique requires much more time to finish than watercolour or mixed media, but it makes it an interesting challenge that I only have greyscale to work with instead of colours.<br /><br />The picture itself is inspired by yin and yang and the constant battle between sides.',
  },
  together_in_the_storm: {
    title: 'Together in the Storm',
    imgs: {
      full: {
        src: require('./together_in_the_storm_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./together_in_the_storm_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper, 297 x 420 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A commissioned painting for a couple. The great black dragon stands protectively over the angel while their little island is battered by stormy seas.',
  },
  there_is_no_up_or_down: {
    title: 'There Is No Up or Down',
    imgs: {
      full: {
        src: require('./there_is_no_up_or_down_2025_web.jpg'),
        width: 1072,
        height: 1500,
      },
      thumb: {
        src: require('./there_is_no_up_or_down_2025_thumb.jpg'),
        width: 429,
        height: 600,
      },
    },
    year: '2025',
    description:
      'Pen, markers and coloured pencils on paper. 250 x 350 mm, 2025.',
    price: 136,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/4487100045/',
    merch: [
      {
        name: 'Colouring Page - Digital',
        url: 'https://www.etsy.com/ie/listing/4488074005/',
        /* prettier-ignore */
        price: 5.50,
        discount: 0,
        isDigital: true,
      },
    ],
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'I drew a digital picture back when I was still in highschool that pictured two dragons flying together with the ground "above" them. I wanted to recreate this concept with Eastern dragons this time.',
  },
  in_the_boars_realm: {
    title: 'In the Boars Realm',
    imgs: {
      full: {
        src: require('./in_the_boars_realm_2025_pannadraws_web.jpg'),
        width: 1500,
        height: 1061,
      },
      thumb: {
        src: require('./in_the_boars_realm_2025_pannadraws_thumb.jpg'),
        width: 600,
        height: 424,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper, 297 x 420 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A commissioned piece to illustrate a tarot reading business website. I was so excited to draw a boar, as this was the first time I was commissioned to paint one.',
  },
  the_dragonslayer: {
    title: 'The Dragonslayer',
    imgs: {
      full: {
        src: require('./the_dragonslayer_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./the_dragonslayer_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper, 297 x 420 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'This commission was a gift to a professor of psychology. The dragon here represents the mental demons she helps defeat.',
  },
  cathorah: {
    title: 'Cathorah',
    imgs: {
      full: {
        src: require('./cathorah_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./cathorah_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description:
      'Pen, markers, coloured pencils and watercolour on paper, 210 x 297 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'A tribute to Gidorah, the legendary monster, and cats.',
  },
  five_dragons: {
    title: 'Five Dragons',
    imgs: {
      full: {
        src: require('./five_dragons_2025_web.jpg'),
        width: 1500,
        height: 1105,
      },
      thumb: {
        src: require('./five_dragons_2025_thumb.jpg'),
        width: 600,
        height: 442,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper, 18 x 24", 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "A large commission, this painting is inspired by a little dragon fan's favourite dragons. I was asked to bring their sketches to life. In fairness the sketches were really imaginative and the variety of the dragons made the making of this piece really enjoyable.",
  },
};

export default imgData_2025;
